import React from "react"
import { NotificationWrapper } from "./NotificationStyles"

export default function Notification({
  text,
  fadeOut,
  isError,
  isAirdrop,
}: any) {
  return (
    <NotificationWrapper
      fadeOut={fadeOut}
      isError={isError}
      isAirdrop={isAirdrop}
    >
      {text}
    </NotificationWrapper>
  )
}
